export const _import_ = file => () => import('@views/' + file + '.vue');



// WEBPACK FOOTER //
// ./src/router/_import.js